document.addEventListener('DOMContentLoaded', function () {
  // Cart page has dedicated scripts; avoid overlapping fixes there.
  if (window.location.pathname === '/cart' || window.location.pathname.startsWith('/cart?')) {
    return;
  }

  // IDs for fallback (price-unit) variants used by calculators
  const FALLBACK_VARIANT_IDS = ["55795499139459", "56535863787907"];
  console.log("Mini cart quantity fix loaded");
  let fixInFlight = false;
  let queuedFix = false;
  let lastRunAt = 0;
  let backoffUntil = 0;

  function fetchCartJson() {
    return fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(async (res) => {
      const text = await res.text();
      if (!res.ok) {
        throw new Error(`cart.js ${res.status}: ${text.slice(0, 120)}`);
      }
      try {
        return JSON.parse(text);
      } catch (e) {
        throw new Error(`cart.js invalid JSON: ${text.slice(0, 120)}`);
      }
    });
  }

  function fixMiniCartQuantity(cart) {
    if (!cart || !cart.items) return;

    // Find mini cart quantity displays
    const miniCartQuantities = document.querySelectorAll('.mini-cart .cart-qty, .header-cart .cart-qty, .cart-count, .mini-cart-count, [class*="cart-count"], [class*="cart-qty"]');

    // Discount splits put one variant on several lines, each carrying the
    // whole order's _Quantity (e.g. 3 lines x _Quantity 3 = 9). Group by
    // variant: split groups count actual line quantities once; separate adds
    // use fresh variants each, so they still sum correctly.
    const variantGroups = {};
    cart.items.forEach(item => {
      const k = item.variant_id.toString();
      (variantGroups[k] = variantGroups[k] || []).push(item);
    });

    let realItemCount = 0;
    cart.items.forEach(item => {
      const props = item.properties || {};
      // Check if this is our custom charge unit
      if (FALLBACK_VARIANT_IDS.includes(item.variant_id.toString()) ||
        item.product_handle === 'custom-charge-unit' ||
        props['_Product Title']) {
        const group = variantGroups[item.variant_id.toString()] || [item];
        if (group.length > 1) {
          // Discount split: several lines, one order. Human total comes from
          // _Quantity (pool and penny alike - penny line qtys are price units,
          // never human counts). Count once, on the first line of the group.
          if (group[0] === item) {
            const hTotal = parseInt(group[0].properties.Quantity || group[0].properties._Quantity || 0, 10);
            realItemCount += hTotal > 0 ? hTotal : group.reduce((s, it) => s + (parseInt(it.quantity, 10) || 0), 0);
          }
        } else {
          // This is a custom glass item - count as the quantity specified in properties
          const itemQuantity = parseInt(props.Quantity || props._Quantity || item.quantity || 1);
          realItemCount += itemQuantity;
        }
      } else {
        // Regular product - count normally
        realItemCount += item.quantity;
      }
    });

    miniCartQuantities.forEach(qtyElement => {
      const newQty = realItemCount.toString();
      if (qtyElement.textContent !== newQty) {
        qtyElement.textContent = newQty;
      }
    });

    // Also update any cart total displays
    const cartTotals = document.querySelectorAll('.cart-total-items, .total-items');
    cartTotals.forEach(total => {
      if (total.textContent.includes('item')) {
        const newText = `${realItemCount} item${realItemCount !== 1 ? 's' : ''}`;
        if (total.textContent !== newText) {
          total.textContent = newText;
        }
      }
    });
  }

  function fixMiniCartItemQuantities(cart) {
    if (!cart || !cart.items) return;

    // Find all cart items in the mini cart
    const cartItems = document.querySelectorAll('.cart-wrapper .item-cart, .widget-shopping-cart .item-cart');

    // Create a map of line items by variant ID for more reliable matching.
    // Split lines share one variant: consume in drawer order so row N pairs
    // with line N instead of every row showing the first line.
    const variantToItemMap = {};
    cart.items.forEach(item => {
      if (!variantToItemMap[item.variant_id]) {
        variantToItemMap[item.variant_id] = [];
      }
      variantToItemMap[item.variant_id].push(item);
    });
    const variantUseCount = {};

    cartItems.forEach((cartItem, index) => {
      // Try to find the product variant ID from the cart item
      const variantIdMatch = cartItem.innerHTML.match(/variant=(\d+)/);
      const variantId = variantIdMatch ? variantIdMatch[1] : null;

      // Find the corresponding cart item
      let matchedItem = null;
      if (variantId && variantToItemMap[variantId] && variantToItemMap[variantId].length > 0) {
        const used = variantUseCount[variantId] || 0;
        matchedItem = variantToItemMap[variantId][Math.min(used, variantToItemMap[variantId].length - 1)];
        variantUseCount[variantId] = used + 1;
      } else if (index < cart.items.length) {
        matchedItem = cart.items[index];
      }

      if (matchedItem) {
        const props = matchedItem.properties || {};
        // Check if this is our custom charge unit
        if (FALLBACK_VARIANT_IDS.includes(matchedItem.variant_id.toString()) ||
          matchedItem.product_handle === 'custom-charge-unit' ||
          props['_Product Title']) {

          // Split lines share the order-wide _Quantity: show the line's own
          // human share = lineQty x orderQty / groupQty (works for pool and
          // penny splits alike - penny line qtys are price units).
          const grp = variantToItemMap[matchedItem.variant_id] || [matchedItem];
          let actualQuantity;
          if (grp.length > 1) {
            const gQty = grp.reduce((s, it) => s + (parseInt(it.quantity, 10) || 0), 0);
            const hTotal = parseInt(props.Quantity || props._Quantity || 0, 10);
            const lineQty = parseInt(matchedItem.quantity, 10) || 0;
            actualQuantity = (gQty > 0 && hTotal > 0) ? Math.max(1, Math.round(lineQty * hTotal / gQty)) : (lineQty || 1);
          } else {
            actualQuantity = parseInt(props.Quantity || props._Quantity || matchedItem.quantity || 1);
          }
          // Update the quantity display
          const priceElement = cartItem.querySelector('.price');
          if (priceElement) {
            const totalItemPrice = matchedItem.line_price;
            const unitPrice = totalItemPrice / actualQuantity;
            const formattedUnitPrice = new Intl.NumberFormat('en-GB', {
              style: 'currency',
              currency: 'GBP'
            }).format(unitPrice / 100);

            const newHtml = `${actualQuantity} \xD7 <span class="amount"><span class="money">${formattedUnitPrice}</span></span>`;
            if (priceElement.innerHTML !== newHtml) {
              priceElement.innerHTML = newHtml;
            }
          }

          // Update the item title (reuse split-aware quantity above)
          const titleElement = cartItem.querySelector('.product-name');
          if (titleElement) {
            let titleText = titleElement.textContent.replace(/\s*\(Qty: \d+\)/, '');
            if (actualQuantity > 1) {
              titleText = `${titleText} (Qty: ${actualQuantity})`;
            }
            if (titleElement.textContent !== titleText) {
              titleElement.textContent = titleText;
            }
          }
        }
      }
    });
  }

  function runAllFixes() {
    const now = Date.now();
    if (now < backoffUntil) return;
    if (fixInFlight) {
      queuedFix = true;
      return;
    }
    if (now - lastRunAt < 1200) return;

    fixInFlight = true;
    lastRunAt = now;

    // Only fetch cart once for all fixes
    const getCart = (typeof simplePool !== 'undefined' && simplePool.getThrottledCart)
      ? simplePool.getThrottledCart.bind(simplePool)
      : fetchCartJson;

    getCart()
      .then(cart => {
        fixMiniCartQuantity(cart);
        fixMiniCartItemQuantities(cart);
      })
      .catch(error => {
        console.log('Cart quantity fix error:', error);
        const message = String(error || '');
        if (message.includes('429') || message.includes('invalid JSON')) {
          backoffUntil = Date.now() + 15000;
        }
      })
      .finally(() => {
        fixInFlight = false;
        if (queuedFix) {
          queuedFix = false;
          setTimeout(runAllFixes, 300);
        }
      });
  }

  function isCalculatorAction(target) {
    if (!target || !target.closest) return false;

    const directCalculatorButton = target.closest(
      '#custom-add-to-cart-button, #brick-add-to-cart-button, .custom-price-calculator .add-to-cart, .brick-calculator .add-to-cart, .custom-calculator-wrapper .add-to-cart, .brick-calculator-wrapper .add-to-cart'
    );
    if (directCalculatorButton) return true;

    const addForm = target.closest('form[action="/cart/add"]');
    if (!addForm) return false;

    // Calculator forms include custom properties; standard catalogue forms usually do not.
    return !!addForm.querySelector('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]');
  }

  const pageHasCalculator = !!document.querySelector(
    '#custom-add-to-cart-button, #brick-add-to-cart-button, .custom-price-calculator, .brick-calculator, .custom-calculator-wrapper, .brick-calculator-wrapper'
  );

  // Run once on every page (drawer + badge live site-wide, not just on
  // calculator pages). Cheap: single throttled fetch, display-only writes.
  setTimeout(runAllFixes, 1200);

  // Run when cart is updated (debounced)
  let updateTimeout;
  document.addEventListener('cart:updated', () => {
    clearTimeout(updateTimeout);
    updateTimeout = setTimeout(runAllFixes, 400);
  });

  // Trigger after user add-to-cart clicks (one debounced run, no DOM polling loops)
  document.addEventListener('click', function (event) {
    if (!isCalculatorAction(event.target)) return;
    clearTimeout(updateTimeout);
    updateTimeout = setTimeout(runAllFixes, 700);
  });

  // Drawer checkout guard: clean carts skip to /checkout as today (no added
  // friction); carts holding an EXPIRED pool line detour to /cart where the
  // recovery banner restores sizes in 1 click. Fail-open on network error to
  // protect conversion. Accelerated buttons / pasted /checkout URLs bypass
  // theme JS on all Shopify plans (residual manual-review risk).
  function isExpiredPoolLine(item) {
    const props = item.properties || {};
    const isPenny = FALLBACK_VARIANT_IDS.includes(item.variant_id.toString());
    const isPoolLine = !isPenny && (props['_Product Title'] === 'Custom Cut Stove Glass' || props['_Product Title'] === 'Custom Cut Brick');
    if (!isPoolLine) return false;
    const price = (Number(item.price) || 0) / 100;
    if (price < 1) return true;
    if (item.sku && (item.sku.indexOf('POOL-') === 0 || item.sku.indexOf('BRICK-POOL-') === 0)) return true;
    // Discount-aware: match against pre-discount original_price too, so offer
    // split lines are never mistaken for expired pool lines.
    const orig = (item.original_price != null ? Number(item.original_price) : Number(item.price) || 0) / 100;
    const exp = parseFloat(props['_Expected Price']);
    if (isFinite(exp) && Math.abs(price - exp) > 0.01 && Math.abs(orig - exp) > 0.01) return true;
    return false;
  }

  document.addEventListener('click', function (event) {
    const co = event.target && event.target.closest
      ? event.target.closest('.cart-checkout a[href="/checkout"], a.checkout-cart[href="/checkout"]')
      : null;
    if (!co) return;
    event.preventDefault();
    const go = (url) => { window.location.href = url; };
    const getCart = (typeof simplePool !== 'undefined' && simplePool.getThrottledCart)
      ? simplePool.getThrottledCart.bind(simplePool)
      : fetchCartJson;
    getCart()
      .then(cart => {
        const dirty = (cart.items || []).some(isExpiredPoolLine);
        go(dirty ? '/cart' : '/checkout');
      })
      .catch(() => go('/checkout'));
  });
});
